import { GraduationCap, Stack } from '@phosphor-icons/react';
import { useAuth } from '../lib/auth';
import { ALL_COURSES, useCourse } from '../lib/course';

/**
 * Card picker shown when there's more than one course and none is selected — for
 * multi-course students and for instructors (who also get an "All courses" card).
 * Picking a card scopes everything to that course; switch anytime from My Courses in the sidebar.
 */
export function MyCourses() {
  const { user } = useAuth();
  const { courses, goToCourse } = useCourse();
  const isInstructor = user?.role === 'instructor';
  return (
    <div className="space-y-6">
      <div>
        <div className="label-mono">{isInstructor ? 'Courses' : 'Your courses'}</div>
        <h1 className="text-2xl font-bold text-brand-navy">Pick a course</h1>
        <p className="mt-1 text-slate-500">
          {isInstructor
            ? 'Choose a course to view as a learner — or all courses together. You can switch anytime from My Courses in the sidebar.'
            : `You're enrolled in ${courses.length} courses. Choose one to continue — switch anytime from My Courses in the sidebar.`}
        </p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {courses.map((c) => (
          <button
            key={c.id}
            onClick={() => goToCourse(c.id)}
            className="rounded-2xl border border-slate-200 bg-white p-6 text-left transition hover:border-brand-teal hover:shadow-md"
          >
            <GraduationCap size={28} weight="bold" className="text-brand-teal" />
            <div className="mt-3 font-semibold text-brand-navy">{c.title}</div>
            {c.description && <p className="mt-1 line-clamp-2 text-sm text-slate-500">{c.description}</p>}
            {c.weeks ? <div className="mt-2 text-xs text-slate-400">{c.weeks} weeks</div> : null}
          </button>
        ))}
        {isInstructor && (
          <button
            onClick={() => goToCourse(ALL_COURSES)}
            className="rounded-2xl border border-dashed border-slate-300 bg-white p-6 text-left transition hover:border-brand-teal hover:shadow-md"
          >
            <Stack size={28} weight="bold" className="text-slate-400" />
            <div className="mt-3 font-semibold text-brand-navy">All courses</div>
            <p className="mt-1 text-sm text-slate-500">View every course's content together (instructor view).</p>
          </button>
        )}
      </div>
    </div>
  );
}
